import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { environment } from '../../environments/environment';
import { AdsComponent } from './ads/ads.component';

const { create, ads } = environment.modules;

const BASE_MODULE = `${create}/${ads}`;

const routes: Routes = [
  {
    path: '',
    data: {
      isMfe: true,
      module: BASE_MODULE
    },
    children: [
      {
        path: 'campaigns',
        component: AdsComponent,
        data: {
          isMfe: true,
          module: BASE_MODULE,
          submodule: BASE_MODULE,
          hideBreadcrumbs: true,
          reuse: true
        },
        children: [
          {
            path: '**',
            component: AdsComponent,
            data: {
              isMfe: true,
              module: BASE_MODULE,
              submodule: 'campaigns',
              reuse: true
            }
          }
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdsMfeRoutingModule { }
